export default "__VITE_PUBLIC_ASSET__9498a947__"